import React from "react";
import { CatalogueReviews, ReviewData } from "../../../common/interfaces";
import { ReviewStars } from "./ReviewStars";
import { CatalogueReview } from "./CatalogueReview";
import "./catalogue-review-component.scss";

// Because of different capitalization of the data we cannot just run .toLowerCase and .replace
// Hire Great Dresses => Great Dresses
// Rent Great Dresses => Great Dresses
// Shop Great Dresses => Great Dresses
// Great Dresses for Hire => Great Dresses
// Great Dresses hire => Great Dresses
const convertHeading = (heading: string | undefined) => {
  if (!heading) {
    return;
  }
  const headingWordArray = heading.split(" ");

  // Remove Hire or Rent or shop from the heading if it's the first word
  const firstWord = headingWordArray[0].toLowerCase();
  if (firstWord === "hire" || firstWord === "rent" || firstWord === "shop") {
    headingWordArray.shift();
  }

  const lastTwoWords = headingWordArray.slice(Math.max(headingWordArray.length - 2, 1));
  if (lastTwoWords.join(" ").toLowerCase() === "for hire") {
    headingWordArray.pop();
    headingWordArray.pop();
  } else if (lastTwoWords[1] && lastTwoWords[1].toLowerCase() === "hire") {
    headingWordArray.pop();
  }

  return headingWordArray.join(" ");
};

export const CatalogueReviewComponent: React.FC<{ reviews: CatalogueReviews; heading?: string }> = ({
  reviews,
  heading
}) => {
  const title = convertHeading(heading);
  return (
    <div className="c-catalogue_reviews_component">
      <h1 className="h1 section-title align-center">Recent {title} Reviews</h1>
      <div className="c-catalogue_reviews_component__summary">
        <div className="c-catalogue_reviews_component__rating-stars">
          <ReviewStars rating={reviews.averageRating} />
        </div>
        <span itemType="http://schema.org/Brand">
          <span itemProp="aggregateRating" itemType="http://schema.org/AggregateRating">
            <span itemProp="reviewCount">{reviews.count}</span> customers who ordered{" "}
            <span itemProp="name">{title}</span> rated on average{" "}
            <span itemProp="ratingValue">{reviews.averageRating}</span> stars
          </span>
        </span>
      </div>
      {reviews.reviews.map((r: ReviewData) => {
        return <CatalogueReview key={r.datetime} {...r} />;
      })}
    </div>
  );
};
